// extracted by css-extract-rspack-plugin
export default {"card":"tqa42jYiqywfCDMe","header":"clVqaKxT_Y0KSS5b","icon":"S1ExVIUvUB0BCCNS","title":"JM9pmZhX2PEVf7z5","count":"xeDdrBmLE2Qr8OpA","body":"VC3sXVIfumovUh8u"};